export default __webpack_public_path__ + "static/media/Stave of the Hell Walker (nm).3f6dbce5.jpg";